import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Popover from './Popover';
import SortingUtil from './util/SortingUtil';
import Store from './store/Store';
import { GLOBAL_SEARCH_INFO } from './store/Constants';
import ViewUtil from './ViewUtil';
import { SORT_BY_KIND } from './util/Constants';
import t from './i18n/I18n';
import './SortingPopover.css';

export default class SortingPopover extends React.Component {
  static propTypes = {
    style: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    showOrder: PropTypes.bool,
    selectedOrder: PropTypes.any
  };

  static defaultProps = {
    style: {}
  };

  state = {
    show: false
  };

  render() {
    const rect = this.refs.sorting ? this.refs.sorting.getBoundingClientRect() : {};

    return (
      <div style={this.props.style} name="SortingPopover">
        <div
          ref="sorting"
          onClick={() => this.setState({ show: true })}
          style={{
            ...styles.sorting,
            backgroundImage: this.state.show ? 'url(images/arrow_up.svg)' : 'url(images/arrow_down.svg)'
          }}>
          {t('SORT_BY')}
        </div>
        {this.state.show ? (
          <Popover top={rect.bottom + 5} left={rect.left - 130} onClose={() => this.setState({ show: false })}>
            <SortingContent {...this.props} close={() => this.setState({ show: false })} />
          </Popover>
        ) : null}
      </div>
    );
  }
}

export class SortingContent extends React.Component {
  static propTypes = {
    values: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    showOrder: PropTypes.bool,
    selectedOrder: PropTypes.any
  };

  static defaultProps = {
    close: _.noop
  };

  state = {
    globalSearchInfo: Store.get(GLOBAL_SEARCH_INFO)
  };

  onClick = (item) => {
    const orderPreference: string[] = SortingUtil.getCriteria2OrderPreference(this.props.selected);
    const orderChanged = orderPreference.indexOf(item) > -1;
    if (orderChanged) {
      if (this.props.onClick) {
        this.props.onClick(this.props.selected, SortingUtil.getLabel2Order(item, this.props.selected));
      }
    } else {
      if (this.props.onClick) {
        this.props.onClick(item, this.props.selectedOrder);
      }
    }

    this.props.close();
  };

  renderSortCriteriaItem = (item) => {
    //This method is for render Sort criteria
    if (ViewUtil.isCollectionTabActive() && item === SORT_BY_KIND) {
      //Check if collection tab is active and Sort by Kind not possible.
      return null;
    }
    /*  if(this.state.globalSearchInfo.active && item === SORT_BY_KIND){         //Check if global Search mode is Active in this Case Sort By Kind not possible.
      return null;
    } */
    return this.renderDropDownItem(item, this.props.selected);
  };

  renderDropDownItem = (item, selected) => {
    //DO not call this directly
    return (
      <div
        key={item + '-' + selected}
        className="item"
        onClick={() => this.onClick(item)}
        style={{ backgroundImage: selected === item ? 'url(images/arrow_down.svg)' : null }}>
        {this.getSortByPropertyName(item)}
      </div>
    );
  };

  renderAscDescOrderItems() {
    //This method is for rendering ASC, DESC order
    const label = SortingUtil.getOrder2Label(this.props.selectedOrder, this.props.selected);
    let orderPreference: string[] = SortingUtil.getCriteria2OrderPreference(this.props.selected);
    orderPreference = orderPreference ? orderPreference : ['ASCENDING', 'DESCENDING'];
    return (
      <div className="asc-desc">
        <div className="divider" />
        {orderPreference.map((order, index) => this.renderDropDownItem(order, label))}
      </div>
    );
  }

  getSortByPropertyName = (item) => {
    item = item.replace('SYST_','');
    const propInfo = window.gs?.propName2PropInfoMap?.get(item)
    return  propInfo ? propInfo.getKey() : t(item);
  }

  render() {
    return (
      <div name="SortingContent">
        <div className="items">
          {this.renderSortCriteriaItem(this.props.selected)}
          {_.size(this.props.values) > 0
            ? this.props.values.map((item) => (item != this.props.selected ? this.renderSortCriteriaItem(item) : null))
            : null}
        </div>
        {this.props.showOrder ? this.renderAscDescOrderItems(this.props.selected) : null}
      </div>
    );
  }
}

const styles = {
  sorting: {
    fontSize: '14px',
    marginRight: '10px',
    paddingRight: '15px',
    cursor: 'pointer',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '100% 50%',
    color: 'var(--primary-font-color)'
  }
};
